// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iconStyle[data-v-1f523d71] {\n  margin-left: 15px;\n  font-size: 24px;\n}\n", ""]);
// Exports
module.exports = exports;
